import * as React from "react";

export const RelayEnvironmentContext = React.createContext<{
  relay_environment: any;
  set_relay_environment: any;
}>({
  relay_environment: null,
  set_relay_environment: null
});
